interface UserThumbnailSource {
    Profile?: UserThumbnailSource;
    profile?: UserThumbnailSource;
    Name?: string;
    FirstName?: string;
    Firstname?: string;
    LastName?: string;
    Lastname?: string;
}

type UserThumbnailInput = UserThumbnailSource | null | undefined;

const INITIALS_BACKGROUND_COLORS = [
    '#e3d6ff',
    '#dbcff6',
    '#d9dcff',
    '#eadcff',
    '#d7d0f4',
    '#e0d8f2',
    '#d9f0df',
    '#d8ebe4',
    '#d7e8d4',
    '#f4d8d8',
    '#f0dcdf',
    '#efd6ce',
    '#d7e4ff',
    '#d9e8f6',
    '#d6edf4',
    '#f4edc9',
    '#f1e3b8',
    '#efe0a6',
];

// Supports both API user objects and the nested Profile shape used by legacy views.
export function getUserThumbnailName(user: UserThumbnailInput): string {
    const profile = user?.Profile || user?.profile || user || {};

    return (
        profile.Name ||
        user?.Name ||
        `${profile.FirstName || profile.Firstname || user?.FirstName || user?.Firstname || ''} ${
            profile.LastName || profile.Lastname || user?.LastName || user?.Lastname || ''
        }`.trim()
    );
}

export function getUserThumbnailInitials(user: UserThumbnailInput): string {
    const words = getUserThumbnailName(user)
        .trim()
        .split(/\s+/)
        .map((word) => word.replace(/[^A-Za-zÀ-ÿ0-9]/g, ''))
        .filter(Boolean);

    if (!words.length) return '';
    if (words.length === 1) return words[0].slice(0, 2).toUpperCase();

    return `${words[0].charAt(0)}${words[words.length - 1].charAt(0)}`.toUpperCase();
}

export function getUserThumbnailInitialsBackgroundColor(user: UserThumbnailInput): string {
    const name = getUserThumbnailName(user);
    let hash = 0;

    for (let index = 0; index < name.length; index += 1) {
        hash = hash * 31 + name.charCodeAt(index);
    }

    return INITIALS_BACKGROUND_COLORS[Math.abs(hash) % INITIALS_BACKGROUND_COLORS.length];
}
